export type TestimonialItem = {
    quote: string;
    name: string;
    role: string;
};

/**
 * Testimonials fold copy — Figma web 2745:21026 / mobile 2541:30640
 * Edit this list to refresh marquee / carousel cards.
 */
export const TESTIMONIALS_NEW: TestimonialItem[] = [
    {
        quote: "These guys have a good track record, so it was a no-brainer for me to invest about 4 lakhs in their first issue. I'll also recommend to my family & friends to invest.",
        name: "Nidhi Agarwal",
        role: "Startup founder",
    },
    {
        quote: "All information required for me to invest has been laid out in a transparent manner. Webinar has helped me take an informed decision.",
        name: "Nidhi Agarwal",
        role: "Startup founder",
    },
    {
        quote: "These guys have a good track record, so it was a no-brainer for me to invest about 4 lakhs in their first issue. I'll also recommend to my family & friends to invest.",
        name: "Lakshminarayanan Iyer",
        role: "Investor",
    },
    {
        quote: "All information required for me to invest has been laid out in a transparent manner. Webinar has helped me take an informed decision.",
        name: "Lakshminarayanan Iyer",
        role: "Investor",
    },
];

export const TESTIMONIAL_STATS = [
    { value: "1.5L+", label: "INVESTORS" },
    { value: "10L+", label: "APP DOWNLOADS" },
] as const;
